/**
 * Estratégias do Caminho.
 *
 * Este módulo é CommonJS porque é espelhado literalmente para Functions. O
 * documento remoto pode faltar ou conter lixo; nesses casos o produto novo é o
 * fallback deliberado, sem feature flag por pessoa.
 */

const TIPOS_CAMINHO = Object.freeze({
  ESTUDO: 'caminho_estudo',
  TREINO_DIETA: 'caminho_com_treinodieta',
});

const TIPO_CAMINHO_PADRAO = TIPOS_CAMINHO.ESTUDO;

/*
 * Versão do contrato que sabe ler `CAMINHO/ESTUDO`.
 *
 * Clientes das lojas anteriores ao Caminho 2.0 não enviam este campo e leem
 * exclusivamente `CAMINHO/ATUAL`. Por isso ausência, lixo ou uma versão menor
 * significam deliberadamente a estratégia legada, mesmo quando a configuração
 * global já aponta para estudo. O campo é capacidade, não autorização.
 */
const CONTRATO_CAMINHO_ESTUDO = 2;

function normalizarTipoCaminho(valor) {
  return Object.values(TIPOS_CAMINHO).includes(valor)
    ? valor
    : TIPO_CAMINHO_PADRAO;
}

function tipoDoDocumento(doc) {
  return normalizarTipoCaminho(doc && doc.TIPO_CAMINHO);
}

function ehCaminhoEstudo(valor) {
  return normalizarTipoCaminho(valor) === TIPOS_CAMINHO.ESTUDO;
}

function clienteSuportaCaminhoEstudo(dados) {
  const versao = Number(dados && dados.CONTRATO_CAMINHO);
  return Number.isInteger(versao) && versao >= CONTRATO_CAMINHO_ESTUDO;
}

/**
 * A configuração habilita o produto; o contrato confirma que o aparelho sabe
 * consumi-lo. Sem as duas condições o endpoint preserva o comportamento antigo.
 */
function tipoCaminhoParaCliente(tipoGlobal, dados) {
  if (ehCaminhoEstudo(tipoGlobal) && clienteSuportaCaminhoEstudo(dados)) {
    return TIPOS_CAMINHO.ESTUDO;
  }
  return TIPOS_CAMINHO.TREINO_DIETA;
}

module.exports = {
  TIPOS_CAMINHO,
  TIPO_CAMINHO_PADRAO,
  CONTRATO_CAMINHO_ESTUDO,
  normalizarTipoCaminho,
  tipoDoDocumento,
  ehCaminhoEstudo,
  clienteSuportaCaminhoEstudo,
  tipoCaminhoParaCliente,
};
